import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('pricing');

export class ProductsWithPricePeriods extends Api {
    constructor(http, config = {}) {
        super(http, url, 'products-with-price-periods', config);
    }
}